import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// استيراد الصفحات
import Login from './pages/auth/Login/Login';
import Dashboard from './pages/dashboard/Dashboard/Dashboard';
import Students from './pages/students/Students/Students';
import Attendance from './pages/attendance/Attendance/Attendance';
import Exams from './pages/exams/Exams/Exams';
import ExamResults from './pages/exams/ExamResults/ExamResults';
import CreateExam from './pages/exams/CreateExam/CreateExam';
import MonthlyReport from './pages/exams/MonthlyReport/MonthlyReport';
import SolveExam from './pages/exams/SolveExam/SolveExam';
import Settings from './pages/settings/Settings/Settings';
import Layout from './components/layout/Layout/Layout';
import Grades from './pages/grades/Grades';
import Groups from './pages/groups/Groups';

import StudentReport from './pages/students/StudentReport';

// 🛡️ البوابة الأمنية (الحارس) — بتتحقق من وجود توكن دخول حقيقي
const ProtectedRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/" />;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* الصفحات المفتوحة للجميع */}
        <Route path="/" element={<Login />} />
        <Route path="/solve-exam/:examId" element={<SolveExam />} /> {/* الطالب يقدر يمتحن من غير ما يفتح الإدارة */}

        {/* 🔒 الصفحات المحمية (غلفناها بالبوابة الأمنية) */}
        <Route path="/dashboard" element={<ProtectedRoute><Layout><Dashboard /></Layout></ProtectedRoute>} />
        <Route path="/students" element={<ProtectedRoute><Layout><Students /></Layout></ProtectedRoute>} />
        <Route path="/attendance" element={<ProtectedRoute><Layout><Attendance /></Layout></ProtectedRoute>} />
        <Route path="/exams" element={<ProtectedRoute><Layout><Exams /></Layout></ProtectedRoute>} />
        <Route path="/exam-results/:examId" element={<ProtectedRoute><Layout><ExamResults /></Layout></ProtectedRoute>} />
        <Route path="/create-exam" element={<ProtectedRoute><Layout><CreateExam /></Layout></ProtectedRoute>} />
        <Route path="/monthly-report" element={<ProtectedRoute><Layout><MonthlyReport /></Layout></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><Layout><Settings /></Layout></ProtectedRoute>} />
        <Route path="/grades" element={<ProtectedRoute><Layout><Grades /></Layout></ProtectedRoute>} />
        <Route path="/groups" element={<ProtectedRoute><Layout><Groups /></Layout></ProtectedRoute>} />
        <Route path="/student-report/:id" element={<ProtectedRoute><Layout><StudentReport /></Layout></ProtectedRoute>} />
      </Routes>
    </Router>
  );
}

export default App;
